<template>
  <div class="login-callback-container">
    <div class="minimal-loading">
      <div class="loading-spinner"></div>
      <p>Verifying authentication...</p>
    </div>
  </div>
</template>

<script>
import tokenManagerService, { oktaAuth } from '../services/tokenManager';

export default {
  name: 'AuthLoginCallback',
  
  data() {
    return {
      processing: false
    };
  },

  async mounted() {
    if (!oktaAuth.isLoginRedirect()) {
      console.warn("⚠️ Loaded callback route without auth params. Redirecting home.");
      this.$router.replace('/');
      return;
    }

    await this.processCallback();
  },

  methods: {
    async processCallback() {
      if (this.processing) return;
      this.processing = true;

      try {
        console.log("🔄 Processing login callback...");
        const originalTarget = await tokenManagerService.handleLoginCallback();
        
        console.log("✅ Login successful.");
        this.navigateAway(originalTarget);

      } catch (error) {
        console.error("❌ Login callback error:", error);

        if (this.isPkceError(error)) {
          console.warn("⚠️ PKCE Error detected. Checking if we are actually authenticated...");
          const token = await tokenManagerService.getValidToken();
          
          if (token) {
            console.log("✅ False alarm. Token exists. Proceeding...");
            this.navigateAway();
            return;
          }
        }

        this.handleFailure(error);
      }
    },

    isPkceError(error) {
      return (
        error.name === 'AuthSdkError' && 
        (error.message.includes('PKCE') || error.message.includes('codeVerifier'))
      );
    },

    navigateAway(target) {
      this.$router.replace(target || '/');
    },

    handleFailure(error) {
      let queryError = 'login_failed';
      if (error.errorCode === 'login_required') queryError = 'session_expired';
      
      this.$router.replace({ path: '/signin', query: { error: queryError } });
    }
  },
};
</script>

<style scoped>
.login-callback-container {
  min-height: 100vh;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(#1e1e2f, #1e1e24);
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: 0;
  padding: 0;
}

.minimal-loading {
  text-align: center;
  color: white;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 3px solid rgba(255, 255, 255, 0.3);
  border-top: 3px solid white;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 16px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.minimal-loading p {
  margin: 0;
  font-size: 14px;
  opacity: 0.9;
}

html, body {
  margin: 0;
  padding: 0;
  height: 100%;
  overflow: hidden;
}
</style>

